import { useEffect } from 'react'
import ThereNoPlaceLikeHomePopupContent from './ThereNoPlaceLikeHomePopupContent'
import useThereNoPlaceLikeHomePopupActions from './useThereNoPlaceLikeHomePopupActions'
import { trackThereNoPlaceLikeHomePopupOpened } from './thereNoPlaceLikeHomePopupAnalytics'
import type { ThereNoPlaceLikeHomePopupMarket, ThereNoPlaceLikeHomePopupVariant } from './thereNoPlaceLikeHomePopupConfig'

interface Props {
  market: ThereNoPlaceLikeHomePopupMarket
  variant: ThereNoPlaceLikeHomePopupVariant
}

function ThereNoPlaceLikeHomePopup(props: Props) {
  const { market, variant } = props
  const { handleActionClick, handleClose, handleRemindMeNextTimeClick } = useThereNoPlaceLikeHomePopupActions(market, variant)

  useEffect(() => {
    trackThereNoPlaceLikeHomePopupOpened(market, variant)
  }, [market, variant])

  return (
    <ThereNoPlaceLikeHomePopupContent
      market={market}
      variant={variant}
      onActionClick={handleActionClick}
      onClose={handleClose}
      onRemindMeNextTimeClick={handleRemindMeNextTimeClick}
    />
  )
}

export default ThereNoPlaceLikeHomePopup
